import React, { createContext, useContext, useState, useEffect } from "react"

interface User {
  id: string
  email: string
  name: string
  role: "admin" | "manager" | "operator" | "customer"
}

interface AuthContextType {
  user: User | null
  login: (email: string, password: string) => Promise<boolean>
  logout: () => void
  loading: boolean
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider")
  }
  return context
}

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Check for stored auth token on app load
    const token = localStorage.getItem("authToken")
    if (token) {
      // In a real app, you'd validate the token with the backend
      const mockUser: User = {
        id: "1",
        email: "admin@logistics.com",
        name: "Admin User",
        role: "admin",
      }
      setUser(mockUser)
    }
    setLoading(false)
  }, [])

  const login = async (email: string, password: string): Promise<boolean> => {
    // Mock authentication - in real app, call your API
    if (email === "admin@logistics.com" && password === "admin123") {
      const mockUser: User = {
        id: "1",
        email: "admin@logistics.com",
        name: "Admin User",
        role: "admin",
      }
      setUser(mockUser)
      localStorage.setItem("authToken", "mock-jwt-token")
      return true
    }
    return false
  }

  const logout = () => {
    setUser(null)
    localStorage.removeItem("authToken")
  }

  const value = {
    user,
    login,
    logout,
    loading,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
